import { Box, Typography } from "@mui/material";
import React, { Fragment } from "react";
import LoginForm from "../../components/Auth/LoginForm";
import LoginHeader from "../../components/Auth/LoginHeader";
import { version } from "../../consts";

export default function Login() {
    return (
        <Fragment>
            <LoginHeader />
            <Box
                display={"flex"}
                sx={{
                    flexShrink: 0,
                    borderRadius: "2rem 2rem 0rem 0rem",
                    background: "#E5EEF5",
                    // minHeight: "42.25rem",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "70vh",
                }}
            >
                <Box
                    display="flex"
                    sx={{
                        flexDirection: "column",
                        gap: "1rem",

                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <LoginForm />
                    <Typography
                        sx={{
                            fontFamily: "Roboto",
                            fontSize: "0.70rem",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                            color: "#023",
                        }}
                    >
                        {`Version `}
                        <b>{version}</b>
                    </Typography>
                </Box>
            </Box>
        </Fragment>
    );
}
